import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/content";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20stylized%20abstract%20cityscape%20at%20dusk%20with%20amber%20and%20terracotta%20tones%2C%20soft%20glowing%20street%20lights%20and%20layered%20geometric%20shapes%2C%20artistic%20editorial%20illustration%20style%2C%20clean%20minimal%20composition%2C%20deep%20warm%20shadows%20for%20text%20contrast&width=1600&height=900&seq=kl-hero-01&orientation=landscape"
        alt="看料91 热门爆料与现场记录聚合阅读平台首页背景"
        title="看料91 热门爆料与现场记录"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55" />

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-8">
          <div className="max-w-3xl animate-fade-up">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm px-3 py-1.5 rounded-full bg-white/15 text-white backdrop-blur border border-white/20 mb-6">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-live-line text-base" />
              </span>
              页面内持续更新 · 点开即可进入浏览
            </span>
            <h1 className="font-heading text-4xl md:text-6xl font-black text-white leading-tight tracking-tight">
              看料91
              <span className="block text-2xl md:text-4xl mt-3 font-bold text-accent-300">
                热门爆料与现场记录聚合
              </span>
            </h1>
            <p className="mt-6 text-sm md:text-lg text-white/85 leading-relaxed max-w-2xl">
              {siteInfo.intro}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/entertainment"
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-md text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                开始翻看内容
              </Link>
              <a
                href="#hot"
                className="px-6 py-3 bg-white/10 text-white border border-white/30 rounded-md text-sm md:text-base hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                查看今日热料
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 max-w-lg">
              <div>
                <dt className="text-xs text-white/70">收录话题</dt>
                <dd className="font-heading text-2xl md:text-3xl font-black text-white">1,200+</dd>
              </div>
              <div>
                <dt className="text-xs text-white/70">内容分类</dt>
                <dd className="font-heading text-2xl md:text-3xl font-black text-white">6</dd>
              </div>
              <div>
                <dt className="text-xs text-white/70">每日更新</dt>
                <dd className="font-heading text-2xl md:text-3xl font-black text-white">30+</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}